import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/LogoScroll.css";

import Logo1 from "../assets/images/Product logo/Ageret.png";
import Logo2 from "../assets/images/Product logo/Angel-Dew.png";
import Logo3 from "../assets/images/Product logo/Azelite-Logo.png";
import Logo4 from "../assets/images/Product logo/BioUv-32.png";
import Logo5 from "../assets/images/Product logo/Niaa-Serum.png";
import Logo6 from "../assets/images/Product logo/Mesojet-logo.png";
import Logo7 from "../assets/images/Product logo/CuMax.png";
import Logo8 from "../assets/images/Product logo/Cutam_PS.png";
import Logo9 from "../assets/images/Product logo/Hydew-Body.png";
import Logo10 from "../assets/images/Product logo/Root-In.png";

const logos = [
  { src: Logo1, alt: "Ageret", link: "/product/SkinCare/ageret" },
  { src: Logo2, alt: "Angel Dew", link: "/product/SkinCare/angeldew" },
  { src: Logo3, alt: "Azelite", link: "/product/SkinCare/azelite" },
  { src: Logo4, alt: "BioUV32", link: "/product/SkinCare/BioUV32" },
  { src: Logo5, alt: "Niaa Serum", link: "/product/SkinCare/niaa-serum" },
  { src: Logo6, alt: "Mesojet", link: "/product/Medical-Engineering/Mesojet" },
  { src: Logo7, alt: "Cumax", link: "/product/SkinCare/Cumax" },
  { src: Logo8, alt: "Cutam", link: "/product/SkinCare/cutam" },
  { src: Logo9, alt: "Hydew Body Lotion", link: "/product/SkinCare/hydewbodylotion" },
  { src: Logo10, alt: "Root In", link: "/product/HairCare/rootin" },
];

const LogoScroll = () => {
  return (
    <section className="logo-section">
      <div className="container-fluid">
        <div className="logo-slider">
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="logo-item">
              <Link to={logo.link}>
                <img src={logo.src} alt={logo.alt} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoScroll;
